export default __webpack_public_path__ + "98afa42250345b5c7e8967b43e9848eb.png";